export const parseMessage = (evt: MessageEventInit) => {
	if (evt.data) {
		if (typeof evt.data === 'string') {
			try {
				return JSON.parse(evt.data)
			} catch {
				// TODO handle thrown error
			}
		} else {
			return evt.data
		}
	}
	return {}
}
